"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/** @deprecated `@faire/slate/icons/Leaf` instead */
export const Leaf = createSVGIcon(
  <>
    <path
      d="M19.732 9.223c3.428 4.834.805 10.371-.463 12.531a2.43 2.43 0 0 1-1.715 1.132c-2.485.428-8.674.908-12-3.926C2.28 14.4 2.417 6.377 2.71 2.554A1.8 1.8 0 0 1 5.143.943c3.686 1.063 11.366 3.72 14.589 8.28Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.177 7.629a89.6 89.6 0 0 1 10.286 14.965"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Leaf",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
